import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=2ce7add4&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports